// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { PermissionAction } from "./permission-action";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 *  Per-floor RBAC scope grant.
 *
 * One row = "this role has `action` authority on
 * this bank floor." References `BankFloor`.id (the canonical floor identity,
 * matching LiftFloor.bank_floor_id), NOT the integer floor number. Absence of
 * ANY RoleFloorPermission rows for a role means the role implicitly has access
 * to all floors (default enforced by consumers).
 */
export class RoleFloorPermission implements flatbuffers.IUnpackableObject<RoleFloorPermissionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RoleFloorPermission {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRoleFloorPermission(
    bb: flatbuffers.ByteBuffer,
    obj?: RoleFloorPermission,
  ): RoleFloorPermission {
    return (obj || new RoleFloorPermission()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsRoleFloorPermission(
    bb: flatbuffers.ByteBuffer,
    obj?: RoleFloorPermission,
  ): RoleFloorPermission {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RoleFloorPermission()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  roleId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankFloorId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  action(): PermissionAction {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : PermissionAction.VIEW;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startRoleFloorPermission(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addRoleId(builder: flatbuffers.Builder, roleIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, roleIdOffset, 0);
  }

  static addBankFloorId(builder: flatbuffers.Builder, bankFloorIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, bankFloorIdOffset, 0);
  }

  static addAction(builder: flatbuffers.Builder, action: PermissionAction) {
    builder.addFieldInt8(3, action, PermissionAction.VIEW);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, deletedAtOffset, 0);
  }

  static endRoleFloorPermission(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // role_id
    builder.requiredField(offset, 8); // bank_floor_id
    return offset;
  }

  unpack(): RoleFloorPermissionT {
    return new RoleFloorPermissionT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.roleId() !== null ? this.roleId()!.unpack() : null,
      this.bankFloorId() !== null ? this.bankFloorId()!.unpack() : null,
      this.action(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: RoleFloorPermissionT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.roleId = this.roleId() !== null ? this.roleId()!.unpack() : null;
    _o.bankFloorId = this.bankFloorId() !== null ? this.bankFloorId()!.unpack() : null;
    _o.action = this.action();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): RoleFloorPermissionT {
    const t = new RoleFloorPermissionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("role_id")) {
      t.roleId = this.roleId() !== null ? this.roleId()!.unpack() : null;
    }
    if (fieldSet.has("bank_floor_id")) {
      t.bankFloorId = this.bankFloorId() !== null ? this.bankFloorId()!.unpack() : null;
    }
    if (fieldSet.has("action")) {
      t.action = this.action();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class RoleFloorPermissionT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public roleId: UuidT | null = null,
    public bankFloorId: UuidT | null = null,
    public action: PermissionAction = PermissionAction.VIEW,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.roleId === null || this.roleId === undefined) {
      throw new Error('Required field "role_id" is not set');
    }
    if (this.bankFloorId === null || this.bankFloorId === undefined) {
      throw new Error('Required field "bank_floor_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const roleId = this.roleId !== null ? this.roleId!.pack(builder) : 0;
    const bankFloorId = this.bankFloorId !== null ? this.bankFloorId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    RoleFloorPermission.startRoleFloorPermission(builder);
    RoleFloorPermission.addId(builder, id);
    RoleFloorPermission.addRoleId(builder, roleId);
    RoleFloorPermission.addBankFloorId(builder, bankFloorId);
    RoleFloorPermission.addAction(builder, this.action);
    RoleFloorPermission.addCreatedAt(builder, createdAt);
    RoleFloorPermission.addUpdatedAt(builder, updatedAt);
    RoleFloorPermission.addDeletedAt(builder, deletedAt);

    return RoleFloorPermission.endRoleFloorPermission(builder);
  }

  clone(): RoleFloorPermissionT {
    const obj = new RoleFloorPermissionT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.roleId = this.roleId !== null ? this.roleId!.clone() : null;
    obj.bankFloorId = this.bankFloorId !== null ? this.bankFloorId!.clone() : null;
    obj.action = this.action;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: RoleFloorPermissionT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.roleId !== null && other.roleId !== null) {
      if (!this.roleId!.equals(other.roleId!)) return false;
    } else if (this.roleId !== other.roleId) return false;
    if (this.bankFloorId !== null && other.bankFloorId !== null) {
      if (!this.bankFloorId!.equals(other.bankFloorId!)) return false;
    } else if (this.bankFloorId !== other.bankFloorId) return false;
    if (this.action !== other.action) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyRoleFloorPermission(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "role_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "bank_floor_id");
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
